let timeoutID = null;

export function debounce(fn, delay) {
	clearTimeout(timeoutID);
	let args = arguments;
	let that = this;
	timeoutID = setTimeout(function () {
		fn.apply(that, args);
	}, delay);
}
